
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 256 256","transform":"scale(.8)"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M57.092 248.7c-2.47 0-4.923-.772-7.019-2.298-3.712-2.695-5.536-7.18-4.76-11.704l12.125-70.702a3.63 3.63 0 00-1.043-3.212L5.03 110.713a11.89 11.89 0 01-3.027-12.266 11.894 11.894 0 019.658-8.143l70.99-10.316a3.62 3.62 0 002.73-1.986l31.748-64.324a11.889 11.889 0 0110.729-6.668c4.588 0 8.7 2.554 10.728 6.668l31.748 64.33a3.627 3.627 0 002.73 1.986l70.993 10.315c4.54.66 8.239 3.78 9.655 8.144 1.416 4.364.258 9.062-3.03 12.265l-51.366 50.066a3.628 3.628 0 00-1.043 3.212l12.126 70.702c.772 4.525-1.051 9.01-4.76 11.704-3.71 2.7-8.537 3.049-12.6.913l-63.495-33.382a3.62 3.62 0 00-3.375-.003l-63.495 33.383a11.995 11.995 0 01-5.58 1.388zm70.765-43.523c1.91 0 3.824.458 5.569 1.374l63.495 33.382c1.798.959 3.273.124 3.819-.275.548-.399 1.787-1.543 1.444-3.549l-12.125-70.7a11.96 11.96 0 013.442-10.593l51.367-50.072c1.458-1.422 1.13-3.074.916-3.717-.208-.644-.913-2.175-2.925-2.467l-70.992-10.316a11.962 11.962 0 01-9.009-6.547L131.111 17.37c-.902-1.826-2.577-2.023-3.254-2.023-.678 0-2.352.197-3.252 2.02l-31.747 64.33a11.968 11.968 0 01-9.009 6.544L12.857 98.557c-2.014.292-2.717 1.823-2.928 2.467-.208.646-.54 2.298.916 3.718l51.37 50.074a11.965 11.965 0 013.442 10.593l-12.125 70.7c-.346 2.006.894 3.147 1.442 3.546.55.4 2.017 1.225 3.818.278l63.498-33.385a11.991 11.991 0 015.567-1.371z","fill":"#000","stroke-width":"0","stroke-miterlimit":"10"}})])
          )
        }
      }
    